// extracted by mini-css-extract-plugin
module.exports = {"title":"SurveyValues_title_15S5K","hint":"SurveyValues_hint_3zd9i"};